export interface Article {
  id: number;
  title: string;
  summary: string;
  content: string;
  date: string;
  author: string;
  image: string;
  tags: string[];
  category: string;
  categoryName: string;
  readTime: string;
}

export const articlesData: Article[] = [
  {
    id: 101,
    title: "篮球基础训练：从零开始的完整指南",
    summary: "系统讲解篮球基本功训练方法，包括运球、传球、投篮和防守脚步动作，帮助零基础学员快速入门。",
    content: `<p>篮球是一项集速度、力量、技巧和团队配合于一体的运动。无论您是零基础的新手还是想系统提升的业余爱好者，掌握正确的基本功训练方法都是第一步。</p>
<h3>一、运球基本功</h3>
<p>运球是篮球最基本也是最重要的技术之一。良好的运球能力让您在场上能够自由移动、创造进攻机会。以下是循序渐进的运球练习方法：</p>
<p><strong>静态运球练习：</strong>双脚与肩同宽，膝盖微屈，用指尖而非手掌控制球。先从右手开始，保持匀速运球，感受球回弹的节奏。每次练习5分钟，然后换左手。关键是要做到不看球也能稳定运球。</p>
<p><strong>行进间运球：</strong>在掌握静态运球后，开始练习走动和慢跑中的运球。注意保持抬头，用余光观察球场情况。练习直线运球、变向运球和背后运球。</p>
<h3>二、投篮技术精讲</h3>
<p>投篮是篮球得分的核心手段。一个标准的投篮动作包含以下关键要素：</p>
<p><strong>站位与平衡：</strong>双脚与肩同宽，投篮手同侧的脚略微靠前半步。身体重心均匀分布在两脚之间，膝盖微屈。</p>
<p><strong>持球手型：</strong>投篮手的手指自然张开，用指腹和掌根接触球，掌心留有空隙。辅助手放在球的侧面，仅用于稳定球，不参与发力。</p>
<p><strong>出手动作：</strong>从腿部发力，力量经腰腹传导至手臂。投篮手肘部内收，手腕柔和拨球，使球产生后旋。出手后手指指向篮筐，保持跟随动作。</p>
<h3>三、防守脚步</h3>
<p>优秀的防守者靠的是脚步移动而非手上动作。防守滑步是最基础的防守脚步：保持低重心，双脚不要交叉，用侧滑步跟上进攻者的移动。练习时可以设置锥桶，进行之字形滑步训练。</p>
<p>云开体育篮球培训课程由资深教练团队执教，通过系统化的训练体系，帮助每一位学员从基础到进阶，享受篮球运动的乐趣。</p>`,
    date: "2026-08-10",
    author: "张教练",
    image: "https://readdy.ai/api/search-image?query=Basketball%20training%20fundamentals%20on%20indoor%20court%2C%20coach%20demonstrating%20dribbling%20technique%20to%20young%20players%2C%20bright%20clean%20gymnasium%20with%20wooden%20floor%2C%20educational%20sports%20photography&width=1200&height=600&seq=art-basketball-101-detail&orientation=landscape",
    tags: ["篮球", "基础训练", "体育培训"],
    category: "training",
    categoryName: "体育培训",
    readTime: "8分钟",
  },
  {
    id: 102,
    title: "游泳技巧进阶：自由泳提速的五大秘诀",
    summary: "针对已有游泳基础的学员，详细讲解自由泳提速技巧。",
    content: `<p>自由泳是速度最快的泳姿，也是竞技游泳中最常用的泳姿。如果您已经掌握了基本的自由泳动作，想要进一步提升速度，以下五大提速秘诀将助您突破瓶颈。</p>
<h3>秘诀一：优化呼吸节奏</h3>
<p>很多游泳者的速度瓶颈来自不合理的呼吸方式。抬头过高会导致身体下沉，增加水阻。正确的做法是：转头而非抬头，嘴巴刚好露出水面吸气，一只眼睛和半边泳镜保持在水下。尝试每3次划臂换一次气（双侧呼吸），保持左右对称。</p>
<h3>秘诀二：提高划水效率</h3>
<p>高效的划水关键在于「抓水」——手掌入水后尽早开始向后推水。想象手臂是一个桨，从入水到出水全程都在向后推动身体前进。入水点不宜太远，在肩膀延长线前方约30厘米处入水最为理想。</p>
<h3>秘诀三：减少身体阻力</h3>
<p>保持身体水平是减少阻力的关键。头部位置至关重要——眼睛看向池底正下方而非前方，这样能保持身体从头到脚在同一水平面。核心肌群收紧，避免腰部和腿部下沉。</p>
<p>云开体育游泳私教课程配备专业水下摄影分析设备，让您直观看到自己的游泳姿态，精准定位问题。欢迎预约体验课程。</p>`,
    date: "2026-08-05",
    author: "李教练",
    image: "https://readdy.ai/api/search-image?query=Professional%20swimmer%20demonstrating%20freestyle%20stroke%20technique%20in%20pool%2C%20crystal%20clear%20water%20with%20underwater%20view%2C%20clean%20modern%20indoor%20pool%20environment&width=1200&height=600&seq=art-swimming-102-detail&orientation=landscape",
    tags: ["游泳", "技巧提升", "体育培训"],
    category: "training",
    categoryName: "体育培训",
    readTime: "6分钟",
  },
  {
    id: 201,
    title: "2026年度云开体育赛事日历发布",
    summary: "云开体育正式发布2026年下半年赛事日历，涵盖12个品类超过50场赛事活动。",
    content: `<p>云开体育正式发布2026年度下半年赛事日历！从城市联赛到全国公开赛，从企业团建到青少年锦标赛，我们为您精心策划了覆盖全年的精彩赛事盛宴。</p>
<h3>赛事日历亮点</h3>
<p><strong>9月：</strong>城市篮球联赛（北京、上海、广州、深圳、成都五城联动）</p>
<p><strong>10月：</strong>全民健身游泳挑战赛（全国各主要城市）、企业足球联赛</p>
<p><strong>11月：</strong>羽毛球公开赛、青少年田径锦标赛</p>
<p><strong>12月：</strong>年度运动盛典暨颁奖典礼、冬季马拉松</p>
<p>全年共计50+场赛事活动，覆盖篮球、足球、羽毛球、游泳、马拉松、网球、乒乓球、健身健美等12个品类。无论您是专业运动员、业余爱好者还是企业团队，都能找到适合自己的赛事。</p>
<p>部分赛事现已开放报名，欢迎关注云开体育官网或APP查看详情。</p>`,
    date: "2026-08-08",
    author: "赛事运营部",
    image: "https://readdy.ai/api/search-image?query=Professional%20sports%20event%20calendar%20display%20in%20modern%20office%20setting%2C%20multiple%20sports%20trophies%20and%20medals%20on%20display%2C%20clean%20corporate%20photography%20style%20with%20warm%20lighting&width=1200&height=600&seq=art-calendar-201-detail&orientation=landscape",
    tags: ["赛事日历", "体育赛事", "赛事组织"],
    category: "events",
    categoryName: "赛事组织",
    readTime: "5分钟",
  },
  {
    id: 301,
    title: "HIIT高强度间歇训练：20分钟高效燃脂方案",
    summary: "通过短时间高强度运动与休息交替的训练模式，20分钟达到传统有氧1小时的热量消耗。",
    content: `<p>HIIT（高强度间歇训练）是近年来最热门的训练方式之一，它以「短时高效」著称——20分钟的HIIT训练可以产生相当于传统有氧运动1小时的燃脂效果。</p>
<h3>HIIT的科学原理</h3>
<p>HIIT通过短时间（20-60秒）的高强度爆发运动与短暂休息交替进行的训练模式，能够在训练结束后持续燃烧热量（后燃效应）。研究表明，HIIT训练后24小时内，身体的基础代谢率仍保持在较高水平。</p>
<h3>20分钟HIIT训练计划</h3>
<p><strong>热身（3分钟）：</strong>开合跳、高抬腿、动态拉伸</p>
<p><strong>主训练（15分钟，每个动作40秒+休息20秒，循环3组）：</strong></p>
<p>1. 波比跳 2. 登山者 3. 深蹲跳 4. 俯卧撑 5. 原地冲刺</p>
<p><strong>放松拉伸（2分钟）</strong></p>
<p>云开体育健身课程提供专业教练指导的HIIT团体课和私教课，帮助您安全高效地进行高强度训练。首次体验免费，欢迎预约！</p>`,
    date: "2026-08-12",
    author: "刘教练",
    image: "https://readdy.ai/api/search-image?query=High%20intensity%20interval%20training%20session%20in%20modern%20gym%2C%20athletic%20person%20doing%20burpees%20with%20determination%2C%20clean%20bright%20fitness%20studio%20with%20mirrors%2C%20professional%20fitness%20photography&width=1200&height=600&seq=art-hiit-301-detail&orientation=landscape",
    tags: ["HIIT", "燃脂", "运动健身"],
    category: "fitness",
    categoryName: "运动健身",
    readTime: "5分钟",
  },
  {
    id: 501,
    title: "儿童运动启蒙：为什么6岁是开始运动的最佳年龄",
    summary: "从儿童生理发育和运动科学角度，分析6岁开始系统运动训练的科学依据。",
    content: `<p>很多家长会问：孩子从几岁开始运动最好？运动科学研究和我们的教学实践都指向同一个答案——6岁。</p>
<h3>6岁的生理发育特点</h3>
<p>6岁是儿童神经系统发育的关键期。此时大脑神经元连接密度达到峰值，学习新运动技能的速度最快。同时，6岁儿童的大肌肉群已经足够强壮，可以开始系统性的运动训练，而精细运动控制也在快速提升。</p>
<h3>不同年龄段的运动推荐</h3>
<p><strong>幼儿启蒙（6-8岁）：</strong>以游戏化运动为主，培养运动兴趣。推荐：基础体操、趣味田径、游泳启蒙。</p>
<p><strong>少儿基础（9-12岁）：</strong>开始技术训练，培养专项兴趣。推荐：篮球、足球、羽毛球、游泳。</p>
<p><strong>青少年进阶（13-15岁）：</strong>强化专项技能，适当增加体能训练。</p>
<p>云开体育青少年训练计划专为不同年龄段孩子设计，用科学的方法让每个孩子爱上运动、健康成长。</p>`,
    date: "2026-08-03",
    author: "青训教研组",
    image: "https://readdy.ai/api/search-image?query=Happy%20children%20aged%20six%20to%20eight%20participating%20in%20fun%20sports%20activities%20on%20green%20field%2C%20coach%20smiling%20and%20guiding%2C%20bright%20sunny%20day%20with%20natural%20light&width=1200&height=600&seq=art-youth-501-detail&orientation=landscape",
    tags: ["儿童运动", "运动启蒙", "青少年训练"],
    category: "youth",
    categoryName: "青少年训练",
    readTime: "6分钟",
  },
];